import { useTranslation } from "react-i18next";
import StarsIcon from "../../../../assets/icons/stars.svg?react";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";

interface ArticleSectionTldrProps {
  article: ArticlePageArticle;
}

export function ArticleSectionTldr({ article }: ArticleSectionTldrProps) {
  const { t } = useTranslation();
  const tldr = article.tldr;

  if (!tldr) return null;

  return (
    <section
      data-gtm-section="tldr"
      data-gtm-order="0"
      className="border-b-0! pb-0!"
    >
      <div className="bg-lemon-background-1 rounded-[8px] p-[16px] text-lime-text-2 font-['DM_Sans',sans-serif] text-[14px] leading-[140%]">
        <span className="inline-flex items-center gap-[4px] font-medium text-sm mb-2">
          <StarsIcon />
          {t("AI Summary")}
        </span>
        <div className="text-sm text-lime-text-2">
          <ScientificText>{tldr}</ScientificText>
        </div>
      </div>
    </section>
  );
}
